<div class="title-welcome">
    <h1>Welcome to Your Attendance!</h1>
  </div>

<a href="dashboard"><button class="back-btn">Dashboard</button></a>